import { loginValidation } from '@/utils/valitation/auth';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import FormField from '../../FormField';
import EyeIcon from '@/components/icons/EyeIcon';
import Eyelock from '@/components/icons/Eyelock';
import { getCookie } from 'cookies-next';
import { signIn } from 'next-auth/react';

function LoginByEmail({ t, setAuth }) {
  const handshake = getCookie('handshake');
  const [show, setShow] = useState(false);
  const handleLogin = async (
    { username, password },
    { setSubmitting, setFieldError }
  ) => {
    const res = await signIn('credentials', {
      username,
      password,
      handshake,
      callbackUrl: '/',
      redirect: false,
    });
    if (!res.ok && res.status !== 200) {
      setFieldError('password', t('WrongEmailPassword'));
    } else {
      setAuth('');
    }
    setSubmitting(false);
  };
  return (
    <section className='mt-3 sm:mt-5'>
      <Formik
        onSubmit={handleLogin}
        initialValues={{
          username: '',
          password: '',
        }}
        validationSchema={loginValidation}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <div className='my-2 sm:my-4'>
              <FormField
                inputClassName='w-full rounded-md border p-1.5 max-sm:placeholder:text-sm max-sm:text-sm sm:p-2 outline-none'
                placeholder={t('Email Address')}
                name='username'
                errorClassName='text-red-600 text-sm mt-1 max-sm:text-xs'
                t={t}
                errors={errors}
                touched={touched}
              />
            </div>
            <div className='my-2 sm:my-4'>
              <FormField
                inputClassName='w-full rounded-md border p-1.5 max-sm:placeholder:text-sm max-sm:text-sm sm:p-2 outline-none'
                placeholder={t('Password')}
                name='password'
                type={show ? 'text' : 'password'}
                icon={
                  show ? (
                    <EyeIcon
                      onClick={() => setShow(false)}
                      className='absolute -translate-y-1/2 cursor-pointer end-2 top-1/2 text-secondary'
                    />
                  ) : (
                    <Eyelock
                      onClick={() => setShow(true)}
                      className='absolute end-2 top-1/2 size-[18px] -translate-y-1/2 cursor-pointer text-secondary'
                    />
                  )
                }
                errorClassName='text-red-600 text-sm mt-1 max-sm:text-xs'
                t={t}
                errors={errors}
                touched={touched}
              />
            </div>
            <div className='flex items-center justify-between mb-2 max-sm:text-sm sm:mb-4'>
              <div className='flex items-center gap-1.5'>
                <input
                  type='checkbox'
                  id='remember-me'
                  className='size-4 appearance-none rounded-md border checked:bg-primary sm:size-[23px]'
                />
                <label
                  htmlFor='remember-me'
                  className='cursor-pointer text-[#525050]'
                >
                  {t('Remember Me ?')}
                </label>
              </div>
              <button
                type='button'
                onClick={() => setAuth('Forgot Password')}
                className='font-semibold underline'
              >
                {t('Forgot Password?')}
              </button>
            </div>
            <button
              disabled={isSubmitting}
              className='flex items-center justify-center w-full gap-4 p-2 font-semibold text-white rounded-md bg-primary hover:bg-primary/90 max-sm:text-sm'
            >
              {isSubmitting && (
                <span className='border-2 border-t border-r border-white rounded-full size-4 animate-spin' />
              )}
              <span>{t('Login')}</span>
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
}

export default LoginByEmail;
